import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../../assets/scss/components/home.scss";
import "../../../assets/scss/components/resouces.scss";
import SearchBtnGroup from "../../../components/CommonCompnents/resourcePage/SearchBtnGroup";
import { getResoucesContent } from "../../../services/Faqs&Resourse/resource";
import { constants, DateFormat } from "../../Constants/commenFeatures";
import Footer from "../Footer";

const Videos = (props) => {
  const [loadMore, setLoadMore] = useState(true);
  const [customResouces, setCustomResouces] = useState([]);

  const loadMoreVideos = () => {
    const body = {
      video: {
        pageDate: customResouces
          ? customResouces[customResouces.length - 1].date
          : "",
        pageLimit: constants.Video,
        tag: [],
      },
    };
    getResoucesContent(getResoucesRes, body);
  };

  const getResoucesRes = (res) => {
    if (res && res.data) {
      setLoadMore(true);
      setCustomResouces([...customResouces, ...res.data?.videos]);
    } else if (res && res.error) {
      setLoadMore(false);
    }
  };

  useEffect(() => {
    const body = {
      video: { pageDate: "", pageLimit: constants.Video, tag: [] },
    };
    getResoucesContent(getResoucesRes, body);
  }, []);
  return (
    <div>
      <div className="container">
        <div className="articleDetail-container">
          <div className="back_btn">
            <i class="edel-icon-arrow-left"></i>
            <span onClick={() => props.history.goBack()}>Back</span>
          </div>
          <div className="artical_page">
            <div className="artical_page_title">
              <h2>Videos</h2>
            </div>
            {customResouces &&
              customResouces.map((video) => {
                return video.ishighlighted === true ? (
                  <div className="articleWraps artical_page_wrap no_border">
                    <div className="vid_banner">
                      <iframe
                        src={video.url}
                        title="YouTube video player"
                        frameborder="0"
                        allow="fullscreen"
                        allowfullscreen
                      ></iframe>
                    </div>
                    <div>
                      <div className="infos">
                        <Link to={`videos/${video.resourceId}`}>
                          <h6>{video.name}</h6>
                        </Link>
                      </div>
                      <div className="display-flex align-center articleWrapsInfo">
                        <p className="date">
                          {DateFormat(video.date, constants.resourceDateFormat)}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : null;
              })}

            <div className="tradingAlgos">
              {customResouces &&
                customResouces.map((video, i) => {
                  return video.ishighlighted !== true ? (
                    <div key={i} className="video_flex articleWraps">
                      <div className="video_view">
                        <iframe
                          src={video.url}
                          title="YouTube video player"
                          frameborder="0"
                          allow="fullscreen"
                          allowfullscreen
                        ></iframe>
                      </div>
                      <div>
                        <div className="infos">
                          <Link to={`videos/${video.resourceId}`}>
                            <h6>{video.name}</h6>
                          </Link>
                        </div>
                        <div className="display-flex align-center articleWrapsInfo">
                          <p className="date">
                            {DateFormat(
                              video.date,
                              constants.resourceDateFormat
                            )}
                          </p>
                          {/* <p>
                            <a
                              className="disabled"
                              href={
                                video.productLink
                                  ? video.productLink
                                  : "javascript:void(0)"
                              }
                            >
                              Product
                            </a>
                          </p> */}
                        </div>
                      </div>
                    </div>
                  ) : null;
                })}
            </div>

            {loadMore && (
              <div className="loadIcon">
                <a href="javascript:void(0)" onClick={loadMoreVideos}>
                  <i className="fas fa-arrow-down"></i>
                  <span>Load more</span>
                </a>
              </div>
            )}

            {/* <div>
            <div className="resouces_btn_section align_left">
              <p>Search for topics related to</p>
              <SearchBtnGroup />
            </div>
          </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Videos;
